// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsAndConditions_wrapper__HI4VN","textBlock":"TermsAndConditions_textBlock__w0mgh"};